import styled, { css } from 'styled-components';
import { mobile_s, mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const Table = styled.div`
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  width: 100%;
  border-radius: var(--border-radius-8);
  .loading-animation {
    overflow: hidden;
  }

  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
const TableHeader = styled.div`
  padding: var(--space-12);
  ${FlexBetween}
  border-radius: var(--border-radius-8) var(--border-radius-8) var(--border-radius-0) var(--border-radius-0);
  background-color: var(--background-tertiary);
  ${mobile_xl(css`
    gap: var(--space-24);
    justify-content: flex-start;
  `)}
`;
const UserName = styled.div`
  ${mobile_xl(css`
    max-width: 170px;
    width: 100%;
  `)}
  ${mobile_s(css`
    max-width: 140px;
  `)}
`;
const TableData = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  ${mobile_xl(css`
    width: 100%;
    justify-content: space-between;
  `)}
`;
const TableDetail = styled.div`
  ${AlignCenter}
  padding: var(--space-11) var(--space-12);
  border-top: 0.5px solid var(--border-primary);
  position: relative;
  .third {
    width: auto;
    padding-left: var(--space-36);
  }
  .forth {
    width: auto;
    padding-left: var(--space-80);
    margin-left: var(--space-12);
    align-items: end;
  }
  .number-last {
    padding-left: var(--space-24);
    margin-left: var(--space-6);
  }
  ${mobile_xl(css`
    padding: var(--space-13) var(--space-12);
    gap: var(--space-20);
    justify-content: space-between;
  `)}
`;
const NameLoading = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  width: 400px;
  .third-top {
    width: 80px;
  }
  .third-bottom {
    width: 100px;
  }
  .forth-top {
    width: 60px;
  }
  .forth-bottom {
    width: 85px;
  }
  ${mobile_xl(css`
    &.third {
      display: none;
    }
    &.forth {
      display: none;
    }
    gap: var(--space-10);
    width: 100%;
    max-width: 170px;
  `)}
`;

const Top = styled.div`
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  width: 100px;
  height: 9px;
  ${mobile_xl(css`
    height: 10px;
  `)}
`;
const Bottom = styled.div`
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  width: 120px;
  height: 6px;
  ${mobile_xl(css`
    height: 8px;
  `)}
`;
const NumberLoading = styled.div`
  ${AlignCenter}
  padding-left: var(--space-48);
  margin-left: var(--space-12);
  .last {
    width: 70px;
  }
  ${mobile_xl(css`
    max-width: 109px;
    width: 100%;
    &.number-last {
      display: none;
    }
    padding-left: var(--space-0);
    margin-left: var(--space-0);
  `)}
`;

const Middle = styled.div`
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  width: 80px;
  height: 6px;
  ${mobile_xl(css`
    height: 10px;
    width: 78px;
  `)}
`;

const Last = styled.div`
  padding-left: var(--space-24);
  ${mobile_xl(css`
    padding-left: var(--space-0);
  `)}
`;
const H1 = styled.div`
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  width: 84px;
  height: 9px;
  ${mobile_xl(css`
    height: 10px;
  `)}
`;
const H2 = styled.div`
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  width: 80px;
  height: 9px;
  ${mobile_xl(css`
    height: 10px;
    width: 78px;
  `)}
`;
const H3 = styled.div`
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  width: 60px;
  height: 9px;
`;
const H4 = styled.div`
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  width: 70px;
  height: 9px;
`;
const Div = styled.div`
  padding-left: var(--space-12);
  border-left: 0.5px solid var(--border-primary);
  &.third-column {
    padding-left: var(--space-48);
    margin-left: var(--space-12);
  }
  &.first-column {
    padding-right: var(--space-10);
  }
  &.second-column {
    margin-left: var(--space-10);
    padding-right: var(--space-48);
  }
  &.last-column {
    width: 18px;
    height: 18px;
    border-left: none;
  }
  ${mobile_xl(css`
    padding-left: var(--space-10);
    &.second-column {
      display: none;
    }
    &.third-column {
      display: none;
    }
    &.fourth-column {
      display: none;
    }
    &.last-column {
      padding-left: var(--space-0);
    }
  `)}
`;
export {
  Table,
  TableHeader,
  UserName,
  TableData,
  TableDetail,
  NameLoading,
  Top,
  Bottom,
  NumberLoading,
  Middle,
  Last,
  H1,
  H2,
  H3,
  H4,
  Div
};
